import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Loader from "react-spinner-loader";
import { useAsyncDebounce } from "react-table";
import * as Yup from "yup";
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { decryptedValue, formatNumberToCrores, isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import { formatDateString, formatDateString1 } from "./borrowingProfile";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { addCreditRating, deleteCreditRating, editCreditRating, getCreditRating } from "http/fundLync/creditRating.helper";
import CommonDialog from "components/Common/CommonDialog";
import { callGetProbeCreditRatings } from "http/fundLync/entityDocuments.helper";

const CreditRatings = ({isOpen,onAccordionToggle }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isAddPOCOpen, setAddPOCOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [creditRatingList, setCreditRatingList] = useState([]);
  const [creditRatingListFromProbe, setCreditRatingListFromProbe] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [creditRatingData, setCreditRating] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isNewDataPermission, setNewDataPermission] = useState(false);
  const [isEditPocPermission, setEditPocPermission] = useState(false);
  const [pocSelectedGroup, setPocSelectedGroup] = useState(null);
  const [selectedViewCreditRating, setSelectedViewCreditRating] = useState(null);
  const [isViewOpen, setViewOpen] = useState(false);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [agencyNameList, setAgencyNameList] = useState([]);
  const [ratingList, setRatingList] = useState([]);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });

  const currentDate = new Date().toISOString().split("T")[0];
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])
  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      agencyName: (creditRatingData && creditRatingData[0].agencyName) || "",
      creditRating: (creditRatingData && creditRatingData[0].creditRating) || "",
      ratedDate: (creditRatingData && creditRatingData[0].ratedDate) || currentDate,
      id: (creditRatingData && creditRatingData[0].id) || "",
    },
    validationSchema: Yup.object({
      agencyName: Yup.string().required("Agency name is Required"),
      creditRating: Yup.string().required("Credit Rating is Required"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const data = {
          id: values.id,
          agencyName: values.agencyName,
          creditRating: values.creditRating,
          ratedDate: values.ratedDate,
          entityId:creditRatingList[0]?.entityId,
        }; 

        editCreditRating(data)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Point of Contact updated",
                showToast: true,
                role: "success",
              })
              callPocAfterSave();
              setAddPOCOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {

        const data = {
            agencyName: values.agencyName,
            creditRating: values.creditRating,
            ratedDate: values.ratedDate,
            entityId:entityId,
        };
        addCreditRating(data)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Bank Details Saved",
                showToast: true,
                role: "success",
              });
              callPocAfterSave();
              setAddPOCOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      validation.resetForm();
    },
  });

  useEffect(() => {
    getDropDownList({ dropdownName: "agency_names" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "agency_names")
            ?.dropdownValues || [];
        setAgencyNameList(dropdownValues);
      })
      .catch((error) => { });
    getDropDownList({ dropdownName: "Ratings" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Ratings")
            ?.dropdownValues || [];
        setRatingList(dropdownValues);
      })
      .catch((error) => {
        console.error(error);
      });
      
    checkPermissions();
  }, []);

  useEffect(() => {
    if (isOpen) {
      getCreditRating({ entityId })
      .then((response) => {
        if (response.status) {
            setCreditRatingList(response?.data?.data);
        }
        else{
            setCreditRatingList([]);
        }
      })
        .catch((error) => {
          console.error(error);
        });
    } checkPermissions();
  }, [isOpen, entityId]);
  


  const checkPermissions = async () => {
    const isAddpermission = await isPermission("address", "create_permission");
    const editAddressPermission = await isPermission("address", "edit_permission");
    setNewDataPermission(isAddpermission);
    setEditPocPermission(editAddressPermission);
  };

  const handleCustomerClicks = () => {
    setAddPOCOpen(true);
    setIsEdit(false);
    setCreditRating(null);
  };

  const handleCancelrClicks = () => {
    validation.resetForm();
    setAddPOCOpen(false);
    setCreditRating(null);
  };

  const EditPocDetails = (id) => {
    setIsEdit(true);
    const filteredData = creditRatingList.filter((elem) => {
      return elem.id == id;
    });

    setCreditRating(filteredData);
    let val = {label: filteredData[0]?.bankName, value: filteredData[0]?.bankName}
    setPocSelectedGroup(val);
    setAddPOCOpen(true);
  };
  
  const callRatingsFromProbe = async () => {
    await callGetProbeCreditRatings({ entityId })
      .then((response) => {
        if (response.status && response?.data?.credit_ratings?.length > 0) {
          setCreditRatingListFromProbe(response?.data?.credit_ratings);
        }
        else {
          setCreditRatingListFromProbe([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
    setAddPOCOpen(false);
    setIsEdit(false);
    if(!isDropdownOpen){
      callRatingsFromProbe()
    }
    if (onAccordionToggle) {
      onAccordionToggle(!isDropdownOpen);
    }
  };

  const callPocAfterSave = () => {
    getCreditRating({ entityId })
      .then((response) => {
        if (response.status) {
          setCreditRatingList(response?.data?.data);
        }
        else{
            setCreditRatingList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const ViewCreditRating = (id) => {
    const selectedData = creditRatingList.find((elem) => elem.id == id);
    setSelectedViewCreditRating(selectedData);
    setViewOpen(true);
  };
  const getDisplayName = (agencyName) => {
    const foundAgency = agencyNameList.find(item => item.dropdownValue === agencyName);
    return foundAgency ? foundAgency.displayName : 'Unknown Agency';
  };

  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deleteCreditRating({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Credit Rating Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            callPocAfterSave();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <Row lg="12">
        <div>
          <Card style={{ padding: "10px" }}>
            <div
              className="d-flex justify-content-between mt-1"
              style={{ cursor: "pointer" }}
              onClick={toggleDropdown}
            >
              <div>
                <h5>Credit Ratings</h5>
              </div>
              <div className="me-2">
                <i
                  className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {isViewOpen && selectedViewCreditRating && (
              <div>
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={() => setViewOpen(false)}
                    >
                      close
                    </Button>
                </div>
              <Row className="mb-3">
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Agency Name</Label>
                  <span className="mb-0 entityDetailsValue" id="agencyView">{selectedViewCreditRating.agencyName || ''}</span>
                    <UncontrolledTooltip placement="top" target="agencyView">
                        {getDisplayName(selectedViewCreditRating.agencyName)}
                    </UncontrolledTooltip>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Credit Rating</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewCreditRating.creditRating}</span>
                </Col>
                <Col sm="6" md="4" lg="4" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Rated Date</Label>
                  <span className="mb-0 entityDetailsValue">{formatDateString(selectedViewCreditRating.ratedDate)}</span>
                </Col>
              </Row>
              </div>
            )}
            {isAddPOCOpen && (
              <div>
                <div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      handleSubmit(e)
                      return false;
                    }}
                  >
                    <Row className="mb-3">
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Select Agency 
                        </Label>
                        <Input
                          name="agencyName"
                          type="select"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.agencyName || ""}
                          invalid={
                            validation.touched.agencyName &&
                            validation.errors.agencyName
                          }
                        >
                          <option value="" disabled>
                            Select Agency 
                          </option>
                          {agencyNameList.map((option) => (
                            <option key={uId()} value={option.dropdownValue} title={option.displayName}>
                              {option.dropdownValue}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.agencyName &&
                          validation.errors.agencyName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.agencyName}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Select Credit Rating 
                        </Label>
                        <Input
                          name="creditRating"
                          type="select"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.creditRating || ""}
                          invalid={
                            validation.touched.creditRating &&
                            validation.errors.creditRating
                          }
                        >
                          <option value="" disabled>
                            Select Credit Rating 
                          </option>
                          {ratingList.map((option) => (
                            <option key={uId()} value={option.dropdownValue}>
                              {option.displayName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.creditRating &&
                          validation.errors.creditRating ? (
                          <FormFeedback type="invalid">
                            {validation.errors.creditRating}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Rated Date 
                        </Label>
                        <Input
                          name="ratedDate"
                          type="date"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={formatDateString1(validation.values.ratedDate) || ""}
                          invalid={
                            validation.touched.ratedDate &&
                            validation.errors.ratedDate
                          }
                          max={currentDate}
                        />
                        {validation.touched.ratedDate &&
                          validation.errors.ratedDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.ratedDate}
                          </FormFeedback>
                        ) : null}
                      </Col>

                    </Row>
                    <Row>
                      <Col className="mb-3">
                        <div className="text-end">
                          <button
                            type="button"
                            className="btn btn-outline-secondary save-customer me-2"
                            onClick={handleCancelrClicks}
                          >
                            Cancel
                          </button>
                          {isEdit ? (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Update
                          </button>
                          ): (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            )}
            {isDropdownOpen && (
              <Row>
                <div className="text-sm-end">
                  {isNewDataPermission && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-rounded mb-2 me-2"
                      onClick={handleCustomerClicks}
                    >
                      <i className="mdi mdi-plus me-1" />
                      New Credit Rating
                    </Button>
                  )}
                </div>
                <Col xs="12" className="mt-1 mb-2">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          <th>Agency Name</th>
                          <th>Credit Rating</th>
                          <th>Rated Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {creditRatingList?.length == 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No data found
                            </td>
                          </tr>
                        ) : (
                            creditRatingList?.map((elem, index) => (
                                
                            <tr key={uId()}>
                              <td>{index + 1}</td>
                              <td>
                                <span id={`agency-${index}`}>{elem.agencyName}</span>
                                <UncontrolledTooltip placement="top" target={`agency-${index}`}>
                                    {getDisplayName(elem.agencyName)}
                                </UncontrolledTooltip>
                              </td>
                              <td>{elem.creditRating}</td>
                              <td>{formatDateString(elem.ratedDate)}</td>
                              <td>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="card-drop"
                                  >
                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                  </DropdownToggle>

                                  {isEditPocPermission && 
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        EditPocDetails(elem.id);
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-16 text-success me-1"
                                        id="edittooltip"
                                      ></i>
                                      Edit
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Edit
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            ViewCreditRating(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-eye font-size-16 text-success me-1"
                                        id="viewtooltip"
                                        ></i>
                                        View
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="viewtooltip"
                                        >
                                        View
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            deleteDetail(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-delete font-size-16 text-success me-1"
                                        id="deletetooltip"
                                        ></i>
                                        Delete
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="deletetooltip"
                                        >
                                        Delete
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                  </DropdownMenu>
                                  }
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            )}
            {isDropdownOpen && (
              <Row>
                <div className="mt-4">
                  <h5 className="">Credit Ratings by probe</h5>{" "}
                </div>
                <Col xs="12" className="mt-1 mb-2">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          <th>Agency Name</th>
                          <th>Credit Rating</th>
                          <th>Rated Date</th>
                          <th>Amount</th>
                          <th>Loan Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {creditRatingListFromProbe?.length == 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No data found
                            </td>
                          </tr>
                        ) : (
                          creditRatingListFromProbe?.map((elem, index) => (
                            <tr key={uId()}>
                              <td>{index + 1}</td>
                              <td>
                                <span id={`agency-${index}`}>{elem?.rating_agency ? elem.rating_agency.toUpperCase() : '-'}</span>
                                <UncontrolledTooltip placement="top" target={`agency-${index}`}>
                                  {getDisplayName(elem?.rating_agency)}
                                </UncontrolledTooltip>
                              </td>
                              <td>{elem.rating}</td>
                              <td>{formatDateString(elem.rating_date)}</td>
                              <td>{elem.amount ? '₹' + ' ' + formatNumberToCrores(elem.amount) : ''}</td>
                              <td>{elem.type_of_loan}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            )}
          </Card>
        </div>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching Data" />
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </React.Fragment>
  );
};

export default CreditRatings;
